import { memo } from 'react';
import { TableHoverContent } from 'foundations-components/transitional/components/Table';
import { Flex } from 'foundations-components/components/Flex';
import { MilestoneSubjectCell, MilestoneStatusCheckbox, MilestoneTitleContent } from '../milestone/MilestoneTableCells/MilestoneSubjectCell';
import { MilestoneDueDateCell, MilestoneDateContent } from '../milestone/MilestoneTableCells/MilestoneDueDateCell';
import { MilestoneOwnerCell, MilestoneOwnerContent } from '../milestone/MilestoneTableCells/MilestoneOwnerCell';
import { MilestoneMenu } from '../milestone/MilestoneMenu';
import { MilestoneSuggestionActions } from '../milestone/MilestoneSuggestionActions';
import { StyledTableCell } from './StyledTableCell';
import { useMilestoneTableSize } from './MilestoneTableSizeContext';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
function MilestoneRowCellsComponent({
  milestone,
  onUpdateTitle,
  onUpdateStatus,
  onUpdateDueDate,
  onDelete,
  ownerCandidates,
  onOwnerChange,
  ownerCandidatesLoading,
  renderAvatar,
  sellerGroupName,
  onToggleMilestoneSidebar,
  suggestion,
  onSuggestionResolved,
  onSuggestionError
}) {
  const size = useMilestoneTableSize();
  const handleDelete = () => onDelete(milestone.milestoneId);
  const handleSuggestionResolved = decision => onSuggestionResolved === null || onSuggestionResolved === void 0 ? void 0 : onSuggestionResolved(milestone.milestoneId, decision);
  const ownerProps = {
    milestone,
    ownerCandidates,
    onOwnerChange,
    ownerCandidatesLoading,
    renderAvatar,
    sellerGroupName
  };
  if (size === 'small') {
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(StyledTableCell, {
        style: {
          verticalAlign: 'top'
        },
        children: /*#__PURE__*/_jsx(MilestoneStatusCheckbox, {
          milestone: milestone,
          onUpdateStatus: onUpdateStatus
        })
      }), /*#__PURE__*/_jsx(StyledTableCell, {
        children: /*#__PURE__*/_jsxs(Flex, {
          flexDirection: "column",
          gap: "200",
          children: [/*#__PURE__*/_jsx(MilestoneTitleContent, {
            milestone: milestone,
            onUpdateTitle: onUpdateTitle,
            onToggleMilestoneSidebar: onToggleMilestoneSidebar,
            suggestion: suggestion
          }), /*#__PURE__*/_jsxs(Flex, {
            alignItems: "center",
            gap: "500",
            children: [/*#__PURE__*/_jsx(MilestoneDateContent, {
              milestone: milestone,
              onUpdateDueDate: onUpdateDueDate,
              paddingInlineStart: "0"
            }), /*#__PURE__*/_jsx(MilestoneOwnerContent, Object.assign({}, ownerProps, {
              showName: false
            }))]
          })]
        })
      }), /*#__PURE__*/_jsx(StyledTableCell, {
        children: /*#__PURE__*/_jsx(Flex, {
          justifyContent: "end",
          alignItems: "center",
          children: suggestion ? /*#__PURE__*/_jsx(MilestoneSuggestionActions, {
            suggestion: suggestion,
            onResolved: handleSuggestionResolved,
            onError: onSuggestionError
          }) : /*#__PURE__*/_jsx(TableHoverContent, {
            children: /*#__PURE__*/_jsx(MilestoneMenu, {
              milestone: milestone,
              onDelete: handleDelete
            })
          })
        })
      })]
    });
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(MilestoneSubjectCell, {
      milestone: milestone,
      onUpdateTitle: onUpdateTitle,
      onUpdateStatus: onUpdateStatus,
      onToggleMilestoneSidebar: onToggleMilestoneSidebar,
      suggestion: suggestion
    }), /*#__PURE__*/_jsx(MilestoneDueDateCell, {
      milestone: milestone,
      onUpdateDueDate: onUpdateDueDate
    }), /*#__PURE__*/_jsx(MilestoneOwnerCell, Object.assign({}, ownerProps, {
      showName: size === 'full'
    })), /*#__PURE__*/_jsx(StyledTableCell, {
      children: /*#__PURE__*/_jsx(Flex, {
        justifyContent: "end",
        alignItems: "center",
        gap: "100",
        children: suggestion ? /*#__PURE__*/_jsx(MilestoneSuggestionActions, {
          suggestion: suggestion,
          onResolved: handleSuggestionResolved,
          onError: onSuggestionError
        }) : /*#__PURE__*/_jsx(TableHoverContent, {
          children: /*#__PURE__*/_jsx(MilestoneMenu, {
            milestone: milestone,
            onDelete: handleDelete
          })
        })
      })
    })]
  });
}
export const MilestoneRowCells = /*#__PURE__*/memo(MilestoneRowCellsComponent);